import React from 'react';
import { MessageCircle, Linkedin, BadgeCheck, MapPin } from 'lucide-react';

const Avatar = ({ member, size = 52 }) => (
  <div
    className="rounded-full flex items-center justify-center font-bold text-white shrink-0"
    style={{ width: size, height: size, backgroundColor: member.color, fontSize: size * 0.36 }}
  >
    {member.initials}
  </div>
);

const MemberCard = ({ member, unlocked, onMessage, onLocked }) => {
  return (
    <div
      data-testid={`member-card-${member.id}`}
      className="relative bg-white border border-slate-200 rounded-2xl p-5 flex flex-col hover:border-slate-300 hover:shadow-[0_12px_40px_-16px_rgba(15,23,42,0.2)] transition-all duration-300"
    >
      <div className="flex items-start gap-4">
        <Avatar member={member} />
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5">
            <h3 className="font-bold text-slate-900 truncate">{member.name}</h3>
            <BadgeCheck className="w-4 h-4 text-emerald-500 shrink-0" />
          </div>
          <p className="text-sm text-slate-600 leading-snug mt-0.5 line-clamp-2">{member.title}</p>
          <p className="text-sm font-semibold text-slate-900 mt-1">{member.company}</p>
        </div>
      </div>

      {member.location && (
        <div className="flex items-center gap-1.5 text-xs text-slate-500 mt-3">
          <MapPin className="w-3.5 h-3.5" /> {member.location}
        </div>
      )}

      {member.skills && member.skills.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-3">
          {member.skills.slice(0, 3).map((s) => (
            <span key={s} className="text-[11px] text-slate-600 bg-slate-100 border border-slate-200 px-2 py-0.5 rounded-md">{s}</span>
          ))}
        </div>
      )}

      {member.founding && (
        <span className="absolute right-4 top-4 text-[9px] font-bold uppercase tracking-wider text-amber-700 bg-amber-50 border border-amber-200 px-2 py-1 rounded-full">Founding</span>
      )}

      <div className="mt-4 pt-4 border-t border-slate-100 flex items-center gap-2">
        {member.linkedin && (
          <a
            href={member.linkedin}
            target="_blank"
            rel="noreferrer"
            data-testid={`member-linkedin-${member.id}`}
            className="flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-[#0a66c2] text-white text-xs font-semibold hover:bg-[#0955a5] transition-colors"
          >
            <Linkedin className="w-3.5 h-3.5" /> LinkedIn
          </a>
        )}
        {unlocked && onMessage && (
          <button
            data-testid={`member-message-${member.id}`}
            onClick={() => onMessage(member)}
            className="inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-slate-900 text-white text-xs font-semibold hover:bg-slate-800 transition-colors"
          >
            <MessageCircle className="w-3.5 h-3.5" /> Message
          </button>
        )}
      </div>
    </div>
  );
};

export { Avatar };
export default MemberCard;
